// Pickup bookings are possible through the end of the next calendar month.
// This bounds how stale schedule data (newly entered holiday closures, changed
// windows) can make a booking invalid, while keeping both visible calendar
// months fully bookable.
export const PICKUP_BOOKING_MONTHS_AHEAD = 2;

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const WINDOW_RE = /^(\w+)\s+(\d{1,2}:\d{2})(?::\d{2})?\s*-\s*(\d{1,2}:\d{2})(?::\d{2})?$/;

// "Monday 09:00:00-12:00:00" -> { day: 'Monday', start: '09:00', end: '12:00' }
export function parsePickupWindow(raw) {
  const match = WINDOW_RE.exec(String(raw || '').trim());
  if (!match) return null;
  return { day: match[1], start: match[2], end: match[3] };
}

function toIsoDate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function isInHolidayRange(dateStr, holidays = []) {
  return holidays.some((h) => dateStr >= h.start_date && dateStr <= h.end_date);
}

// Last day of the bookable period (end of the month PICKUP_BOOKING_MONTHS_AHEAD - 1 from now)
function horizonEnd(now = new Date()) {
  return new Date(now.getFullYear(), now.getMonth() + PICKUP_BOOKING_MONTHS_AHEAD, 0);
}

// Next occurrences of ANY of the given weekdays (starting tomorrow), holidays excluded,
// sorted ascending. Used by the checkout calendar: every returned date is bookable.
export function listValidPickupDates({ windowDays = [], holidays = [] } = {}) {
  const targetDows = [...new Set(windowDays)]
    .filter((d) => DAY_NAMES.includes(d))
    .map((d) => DAY_NAMES.indexOf(d));
  if (targetDows.length === 0) return [];

  const dates = [];
  const cursor = new Date();
  cursor.setDate(cursor.getDate() + 1);
  const limit = horizonEnd().getTime();
  while (cursor.getTime() <= limit) {
    if (targetDows.includes(cursor.getDay())) {
      const iso = toIsoDate(cursor);
      if (!isInHolidayRange(iso, holidays)) dates.push(iso);
    }
    cursor.setDate(cursor.getDate() + 1);
  }
  return dates.sort();
}

export function weekdayNameFromIso(iso) {
  return DAY_NAMES[new Date(`${iso}T00:00:00`).getDay()] || null;
}

export function formatPickupDate(dateStr, langCode) {
  const locale = langCode === 'de' ? 'de-CH' : 'en-GB';
  return new Date(`${dateStr}T00:00:00`).toLocaleDateString(locale, {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
